export const beginningOfTime = new Date(0);
